<template>
    <div class="dashboard-welcome-root">
        <div class="welcome-card">
            <img class="welcome-logo" src="@/assets/resource/icon/hover_logo.png" alt="MEDIVER 로고" />
            <div class="welcome-title">안녕하세요, 관리자 페이지 접속을 환영합니다!</div>
            <div class="welcome-desc">
                좌측의 메인 메뉴를 이용하여 원하는 화면으로 이동 할 수 있습니다.<br />
                이용이 끝나면 보안을 위해 우측 상단 메뉴의 '로그아웃' 메뉴를 선택하여 종료해주시기 바랍니다.
            </div>
        </div>
    </div>
</template>

<style scoped>
    .dashboard-welcome-root {
        display: flex;
        justify-content: center; /* 중앙 가로 정렬 */
        align-items: center;     /* 중앙 세로 정렬 */
        height: 80vh;            /* 상단바/좌측메뉴 제외하고 화면 중앙 */
        min-height: 480px;
        background: #f6f7fb;
    }

    .welcome-card {
        background: #fff;
        border-radius: 18px;
        box-shadow: 0 2px 16px #eaedf3;
        padding: 45px 38px 40px 38px;
        text-align: center;
        min-width: 420px;
        max-width: 540px;
    }

    .welcome-logo {
        width: 154px;
        margin-bottom: 26px;
    }

    .welcome-title {
        font-size: 21px;
        font-weight: 700;
        color: #1d3044;
        margin-bottom: 20px;
    }

    .welcome-desc {
        font-size: 17px;
        color: #46585d;
        line-height: 1.8;
        margin-bottom: 8px;
        letter-spacing: -0.3px;
    }
</style>
